module.exports = __webpack_public_path__ + "media/images/field-dropdown-7f4da8d12f90b2e9e9b9687869f2309a.svg";